const PLAYED_DATE_FORMATTER = new Intl.DateTimeFormat('en-US', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
})

const PLAYED_TIME_FORMATTER = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: '2-digit',
})

export type BogglePlayedDateTimeParts = {
  date: string
  time: string
}

const DEFAULT_INVALID: BogglePlayedDateTimeParts = {
  date: '—',
  time: '—',
}

/**
 * Shared date + time parts for run history, run details, and lexicon word stats.
 */
export function formatBogglePlayedDateTime(
  isoString: string,
  invalid: BogglePlayedDateTimeParts = DEFAULT_INVALID,
): BogglePlayedDateTimeParts {
  const date = new Date(isoString)
  if (Number.isNaN(date.valueOf())) {
    return invalid
  }
  return {
    date: PLAYED_DATE_FORMATTER.format(date),
    time: PLAYED_TIME_FORMATTER.format(date),
  }
}
